import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {Process} from '../message/Process';
import {ProcessCriteria} from './ProcessCriteria';
import {ProcessScenario} from './ProcessScenario';

export class ProcessWrapper extends BaseWrapper<Process, ProcessCriteria, ProcessScenario>  {}

